import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';
import type { AdviceRoomTaskState } from 'types/entities/adviceRoomTask';

export interface AdviceRoomTasksPatchOptions {
  content?: string;
  state?: AdviceRoomTaskState;
}

export function adviceRoomTaskApi(path: string) {
  return {
    path,
    PATCH: (params: AdviceRoomTasksPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
    DELETE: () => api.delete(path),
  };
}
